import { useGlobal } from '@/utils/useGlobal';
import EFPicture from '@elem/ui/ef-picture';
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import styles from './index.module.scss';

const MoveCloser = () => {
    const { useLang } = useGlobal();
    const { t } = useLang('OceanProHomeSolarBattery');
    const [enter, setEnter] = useState({
        label: false,
        title: false,
        desc: false,
    });
    const [isPad, setIsPad] = useState(-1);
    const refCover = useRef<HTMLDivElement>(null);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const isPadValue = window.innerWidth < 1024 ? 1 : 0;
            setIsPad(isPadValue);
        }
    }, []);

    useEffect(() => {
        if (typeof window !== 'undefined' && window.innerWidth >= 768) {
            const fn = () => {
                const sceneCover = AniContainer.create({
                    triggerElement: `.${styles.moveCloser}`,
                    triggerHook: 1,
                    offset: '100%',
                    duration: '50%',
                    // onProcess: (_: number) => {
                    //     console.log('----', _);
                    //     if (refCover.current) {
                    //         refCover.current.style.opacity = _.toString();
                    //     }
                    // },
                    syncFromTo: [[refCover.current, { opacity: 0 }, { opacity: 1 }]],
                });
                const aniArr = ['label', 'title', 'desc'];
                const scenes: any = {};
                // 1. 文字动效
                aniArr.forEach((item) => {
                    const domInfo: HTMLDialogElement | null = document.querySelector(`.${styles.moveCloser} .info .${item}`);
                    if (domInfo) {
                        scenes[item] = AniContainer.create({
                            triggerElement: `.${styles.moveCloser}`,
                            triggerHook: 1,
                            offset: window.innerHeight * 1.5 + domInfo.offsetHeight,
                            duration: '150%',
                            onEnter: () => setEnter((prev) => ({ ...prev, [item]: true })),
                            onLeave: () => setEnter((prev) => ({ ...prev, [item]: false })),
                        });
                    }
                });
                return () => {
                    sceneCover.destroy();
                    Object.values(scenes).forEach((item: any) => item.destroy());
                };
            };
            fn();
            window.addEventListener('load', fn);
            return () => {
                window.removeEventListener('load', fn);
            };
        }
    }, []);

    return (
        <div className={`${styles.moveCloser} GtmModuleData-section`} data-section-id={styles.moveCloser} data-section-title={t(`move_closer_title`)}>
            <div className="sticky">
                <div className="img-box">
                    <EFPicture
                        src={'https://websiteoss.ecoflow.com/upload/image/1760001369531/MoveCloser-pc.jpg'}
                        srcPad="https://websiteoss.ecoflow.com/upload/image/1760001369782/MoveCloser-pad.jpg"
                        srcMobile="https://websiteoss.ecoflow.com/upload/image/1760001369289/MoveCloser-h5.jpg"
                        alt={t('move_closer_title')}
                    />
                    <div className="cover" ref={refCover}></div>
                    <div className="info">
                        <p className={`label${enter.label ? ' enter' : ''}`}>{t('move_closer_sub_title')}</p>
                        <h2 className={`title${enter.title ? ' enter' : ''}`}>{t('move_closer_title')}</h2>
                        <p className={`desc${enter.desc ? ' enter' : ''}`}>{t('move_closer_desc')}</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default MoveCloser;
